import { BusIconNoBorder, FootpathIcon, REIcon, SBahnIconNoBorder, TramIconNoBorder, UBahnIconNoBorder, TaxiBusIconNoBorder, TaxiBusIcon } from "../icons/Icons";

/* eslint-disable eqeqeq */
export function getColor(transport) {
    let color = 'red';
    if (transport == "U-Bahn") {
        color = '#03548B';
    } else if (transport == "S-Bahn") {
        color = '#138128';
    } else if (transport == "Straßenbahn") {
        color = '#BE1414';
    } else if (transport == "Niederflurbus" || transport == "Bus" || 
                transport == "Ersatzverkehr" || transport == "SB" || 
                transport == "SEV" || transport == "KleinBus" || transport == "TaxiBus") {
        color = '#8B1260';
    } else if (transport == "Regionalzug") {
        color = '#003366';
    } else if (transport == "footpath") {
        color = '#69AA18';
    } else if (transport == "Fahrrad") {
        color = '#EEEE18';
    } else {
        //console.log(transport);
    }
    return color;
}

export function getDelayedTime(time, delay) {
    if (!time) {
        return "00:00";
    }
    let min = Number(time.split(":")[1]);
    let hours = Number(time.split(":")[0]);

    if (delay) {
        min = Number(delay.split(":")[1]);
        hours = Number(delay.split(":")[0]);
    }

    if (min >= 60) {
        min -= 60;
        hours++;
        if (hours >= 24) {
            hours -= 24;
        }
    }
    if (hours < 10) {
        hours = "0" + hours;
    }
    if (min < 10) {
        return hours + ":0" + min;
    } else {
        return hours + ":" + min;
    }
}

export function isDelayed(time, delay) {
    if (!time || !delay) return false;

    time = time.slice(11, -8)
    delay = delay.slice(11, -8)

    let min = Number(time.split(":")[1]);
    let hours = Number(time.split(":")[0]);

    let minDelay = Number(delay.split(":")[1]);
    let hoursDelay = Number(delay.split(":")[0]);

    if (hoursDelay > hours) return false;

    if (minDelay > min && hours >= hoursDelay) return true;
}

export function getTimeOfSeconds(time) {
    let mins = time / 60;
    let hours = 0;
    if (mins > 60) {
        hours = Math.floor(mins / 60);
        mins = mins - hours * 60;
    }
    return "0" + hours + ":" + (mins < 10 ? "0" + mins : mins);
}

export function getIconForTransportType(transportType, height = "40px") {
    switch (transportType) {
        case "U-Bahn":
            return (
                <div className="iconHolder" style={{ height: height,background: getColor(transportType) }}>
                    <UBahnIconNoBorder className="transportIcon" style={{height: height}} />
                </div>
            )
        case "S-Bahn":
            return (
                <div className="iconHolder round" style={{ height: height,background: getColor(transportType) }}>
                    <SBahnIconNoBorder className="transportIcon"  style={{height: height}} />
                </div>
            )
        case "Ersatzverkehr":
        case "Bus":
        case "Niederflurbus":
            return (
                <div className="iconHolder round" style={{ height: height,background: getColor(transportType) }}>
                    <BusIconNoBorder className="transportIcon" style={{height: height}}  />
                </div>
            )
        case "Straßenbahn":
            return (
                <div className="iconHolder" style={{ height: height,background: getColor(transportType) }}>
                    <TramIconNoBorder className="transportIcon"  style={{height: height}} />
                </div>
            )
        case "Regionalzug":
            return (
                <div className="iconHolder" style={{ height: height,background: getColor(transportType) }}>
                    <REIcon className="transportIcon" style={{height: height}}  />
                </div>
            )
            case "TaxiBus":
                return(
                    <div className="iconHolder round" style={{ height: height,background: getColor(transportType) }}>
                    <TaxiBusIconNoBorder className="transportIcon" style={{height: height}}  />
                </div>
                )
        case "footpath":
            return (
                <div className="iconHolder round" style={{ height: height,background: getColor(transportType) }}>
                    <FootpathIcon className="transportIcon" style={{height: height}}  />
                </div>
            )
        default:
            console.log(transportType);
            return null;
    }
}

export function doubleDigits(val){
    if(val < 10){
        return "0" + val;
    }
    return val;
}